import axios from 'axios';

export async function getMyReferred(repo_id) {
    const URL = `${process.env.REACT_APP_NEW_CRM}/v2/referrals/leads/${repo_id}`;

    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        return { error };
    }
}

export async function getReferralsPrograms() {
    const URL = `${process.env.REACT_APP_NEW_CRM}/v1/referrals/programs`;

    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}

export async function getReferrerPersonalInfo(repoId) {
    const URL = `${process.env.REACT_APP_NEW_CRM}/v2/referrer/${repoId}`;

    try {
        const response = await axios.get(URL);
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}
